import { Hero } from '@/components/notion/Hero';
import { HowNotionWorks } from '@/components/notion/HowNotionWorks';
import { WhatIsNotion } from '@/components/notion/WhatIsNotion';
import { CustomersReviews, HowItWorks, Prices, Switching, Trust } from '@/components/shared';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { config } from '@/pageConfig/notion/us/en';

const ReviewsPage = () => {
  return (
    <Layout headerActions={config.layout.headerActions} pt={[74, 63, 160]}>
      <SEO {...config.seo} />
      <PageWrapper>
        <Hero {...config.hero} />
        <HowNotionWorks {...config.howNotionWorks} />
        <WhatIsNotion {...config.whatIsNotion} />
        <CustomersReviews {...config.customersReviews} />
        <Prices {...config.prices} />
        <Switching {...config.switching} />
        <HowItWorks {...config.howItWorks} {...config.howItWorks.layout} />
        <Trust {...config.trust} />
      </PageWrapper>
    </Layout>
  );
};

export default ReviewsPage;
